var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"popover-item"},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.icon)?_vm._t("icon"):_vm._e(),(_vm.$slots.label)?_vm._t("label"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }